import React, {ReactNode} from 'react';
import RouteContext from '@shared/route/RouteContext';
import {RouteProviderConfig} from '@shared/route/types';

export interface RouteProviderProps {
  config: RouteProviderConfig;
  children: ReactNode;
}

function RouteProvider({children, config}: RouteProviderProps) {
  // TODO 추후 라우팅 관련 유틸이 있다면 이곳에
  return <RouteContext.Provider value={config}>{children}</RouteContext.Provider>;
}

export default RouteProvider;
